import { Inject, Injectable, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { __read } from 'tslib';
import { StateService } from '../services/state.service';


var ISO8601_DATE_REGEX = /^(\d{4})-?(\d\d)-?(\d\d)(?:[T\s](\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;

function isDate(value:any) {
    return value instanceof Date && !isNaN(value.valueOf());
}

function isoStringToDate(match:any) {
    var date = new Date(0);
    var tzHour = 0;
    var tzMin = 0;
    // match[8] means that the string contains "Z" (UTC) or a timezone like "+01:00" or "+0100"
    var dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear;
    var timeSetter = match[8] ? date.setUTCHours : date.setHours;
    // if there is a timezone defined like "+01:00" or "+0100"
    if (match[9]) {
        tzHour = Number(match[9] + match[10]);
        tzMin = Number(match[9] + match[11]);
    }
    dateSetter.call(date, Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    var h = Number(match[4] || 0) - tzHour;
    var m = Number(match[5] || 0) - tzMin;
    var s = Number(match[6] || 0);
    var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
    timeSetter.call(date, h, m, s, ms);
    return date;
}

export function toDate(value: any, tm: any) {
    let timezoneOffset = tm * 60000 * 60
    if (isDate(value)) {
        return new Date(value.getTime() + timezoneOffset);
    }
    if (typeof value === 'number' && !isNaN(value)) {
        return new Date(new Date(value).getTime() + timezoneOffset);
    }
    if (typeof value === 'string') {
        value = value.trim();
        var parsedNb = parseFloat(value);
        // any string that only contains numbers, like "1234" but not like "1234hello"
        if (!isNaN(value - parsedNb)) {
            return new Date(new Date(parsedNb).getTime() + timezoneOffset) 
        }
        if (/^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
            /* For ISO Strings without time the day, month and year must be extracted from the ISO String
            before Date creation to avoid time offset and errors in the new Date.
            If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
            date, some browsers (e.g. IE 9) will throw an invalid Date error.
            If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the timeoffset
            is applied.
            Note: ISO months are 0 for January, 1 for February, ... */
            var _a = __read(value.split('-').map(function (val: any) { return +val; }), 3), y = _a[0], m = _a[1], d = _a[2];
            return new Date(new Date(y, m - 1, d).getTime() + timezoneOffset) ;
        }
        var match = void 0;
        if (match = value.match(ISO8601_DATE_REGEX)) {
            return isoStringToDate(match);
        }
    }
    var date = new Date(value);
    if (!isDate(date)) {
        throw new Error("Unable to convert \"" + value + "\" into a date");
    }
    return date;
}


export function setTimZone(offset: number) {
    let str
    let os = offset
    str = os >= 0 ? str = '+' : '-'
    os < 10 && os > -10 ? str += 0 : null
    str += os + '00'
    return str
}

@Injectable()
@Pipe({
    name: 'date',
   /* pure: true*/
})
export class XDatePipe extends DatePipe implements PipeTransform {
    constructor(
        @Inject(LOCALE_ID) locale: string,
        private ss: StateService
    ) {
        super(locale);
    }

    override transform(value: Date | string | number, format?: string, timezone?: string | number, locale?: string): string | null;
    override transform(value: null | undefined, format?: string, timezone?: string | number, locale?: string): null;
    override transform(value: Date | string | number | null | undefined, format?: string, timezone?: string | number, locale?: string): string | null;
    override transform(value: Date | string | number | null | undefined, format = 'mediumDate', timezone: number = this.ss.browserTimeZone, locale?: string): string | null {
        value = toDate(value, timezone - this.ss.browserTimeZone)
        const match = format.match(/((j{1,2})[.\s](K{1,2}))?(([.\s])?(q{1,4}))/);
        if (match) {
            const now = new Date(new Date().getTime() + ((timezone - this.ss.browserTimeZone) * 60000 * 60));
            const date =  toDate(value, timezone - this.ss.browserTimeZone);
            if (match[1]) {
                let replacement = '';
                if ((date.getFullYear() !== now.getFullYear()) || (date.getMonth() !== now.getMonth()) || (date.getDate() !== now.getDate())) {
                    replacement = match[1].replace(new RegExp('j', 'g'), 'd').replace(new RegExp('K', 'g'), 'M');
                }
                format = format.replace(match[1], replacement);
            }
            if (match[4]) {
                let replacement = '';
                if (date.getFullYear() !== now.getFullYear()) {
                    replacement = (match[5]||'') + ('' + date.getFullYear()).slice(('' + date.getFullYear()).length - match[6].length, ('' + date.getFullYear()).length);
                }
                format = format.replace(match[4], replacement);
            }
        }
        let result = super.transform(value, format, setTimZone(timezone) , locale);
        if (result === null || result === '' || result !== result) {
            return null;
        }
        return result;
    }
}
